import React from "react";
import Content from "../Content/Content";
import { ReactComponent as LogoPrivacidadeCap } from "./../../assets/icons/logo-caixa-consorcio.svg";
import * as S from "./PortalPrivacidadeHeader.style";

const PortalPrivacidadeHeader = () => {
  return (
    <>
      <S.Header>
        <Content>
          <a href={"#top"}>
            <LogoPrivacidadeCap />
          </a>
        </Content>
      </S.Header>
      <S.Hr></S.Hr>
    </>
  );
};

export default PortalPrivacidadeHeader;
